/**
 * AnnouncementBanner - shown on all authenticated student dashboards.
 * Fetches the currently-active announcement (if any) and renders a dismissible banner.
 */
import { useEffect, useState } from "react";
import { api } from "@/App";
import { X, Info, AlertTriangle, CheckCircle2 } from "lucide-react";

const STYLES = {
  info: { bg: "bg-primary/10 border-primary/30 text-primary-foreground", icon: Info, iconClass: "text-primary" },
  success: { bg: "bg-success/10 border-success/30 text-foreground", icon: CheckCircle2, iconClass: "text-success" },
  warning: { bg: "bg-warning/10 border-warning/30 text-foreground", icon: AlertTriangle, iconClass: "text-warning" },
};

const AnnouncementBanner = () => {
  const [item, setItem] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/announcement/active").then((d) => {
      const a = d.announcement;
      if (!a) return;
      const seen = localStorage.getItem("dismissed_announcement");
      if (seen !== a.id) setItem(a);
    }).catch(() => {});
  }, []);

  if (!item || dismissed) return null;
  const style = STYLES[item.severity] || STYLES.info;
  const Icon = style.icon;

  return (
    <div data-testid="announcement-banner" className={`mb-4 rounded-xl border ${style.bg} px-4 py-3 flex items-start gap-3`}>
      <Icon className={`w-4 h-4 mt-0.5 flex-shrink-0 ${style.iconClass}`} />
      <p className="text-sm flex-1">{item.message}</p>
      <button
        data-testid="announcement-dismiss"
        onClick={() => { localStorage.setItem("dismissed_announcement", item.id); setDismissed(true); }}
        className="p-1 rounded hover:bg-black/10"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default AnnouncementBanner;
